/**
 * @module GuestApis 
 */

 import store from '@/store/store';
 import Env from '@/env';
 import NormalApis from '@/Components/Controllers/NormalApis';
 
 
 export default {
    
     /**
      * Get details via token
      */
     getGuestDetails(token) {
       const url = `${Env.loginUrl}/api/v1/users/guest_user/${token}`;
       return NormalApis.getApi(url, {
        'api-token': Env.loginApiToken
       })
       .then(res => res)
       .catch(err => err);
     },
     
 }